<script setup lang="ts">
import { Analytics } from '@vercel/analytics/vue';
import { SpeedInsights } from '@vercel/speed-insights/vue';
</script>

<template>
  <router-view v-slot="{ Component }">
    <keep-alive include="HomePage,MyUnitsPage">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <Analytics />
  <SpeedInsights />
</template>
<style>
body {
  user-select: none; /* Standard */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE10+ */
}
</style>
